var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKitchenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08366 10.333H10.417V5.33301H7.08366V10.333ZM7.08366 25.333H10.417V16.9997H7.08366V25.333ZM3.75033 33.6663C2.83366 33.6663 2.04921 33.3402 1.39699 32.688C0.74477 32.0358 0.418103 31.2508 0.416992 30.333V15.333H27.0837V30.333C27.0837 31.2497 26.7575 32.0347 26.1053 32.688C25.4531 33.3413 24.6681 33.6674 23.7503 33.6663H3.75033ZM0.416992 11.9997V3.66634C0.416992 2.74967 0.743659 1.96523 1.39699 1.31301C2.05033 0.660786 2.83477 0.334119 3.75033 0.333008H23.7503C24.667 0.333008 25.452 0.659675 26.1053 1.31301C26.7587 1.96634 27.0848 2.75079 27.0837 3.66634V11.9997H0.416992Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenIcon);
export default __webpack_public_path__ + "static/media/KitchenIcon.76ef5152b0e15900554a065982e5aaea.svg";
export { ForwardRef as ReactComponent };